var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationDisable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3713 25.3683L20.3712 25.3677C20.3546 25.2954 20.3356 25.2173 20.3152 25.1334C20.1656 24.5172 19.9401 23.589 20.0193 22.3687C20.1098 20.9756 20.5851 19.261 21.8442 17.0803C23.4153 14.3589 22.7779 11.0725 20.4874 9.02922L19.8802 8.48761L20.287 7.78299L20.7755 6.93699C20.9138 6.69744 20.8313 6.39191 20.5933 6.25445C20.3552 6.117 20.0494 6.19839 19.9111 6.43794L19.4226 7.28394L19.0158 7.98855L18.2432 7.73355C15.3284 6.77156 12.1635 7.8627 10.5924 10.5841C9.33333 12.7648 8.08606 14.0337 6.92491 14.8086C5.90776 15.4874 4.99111 15.7562 4.38261 15.9347C4.29976 15.959 4.22262 15.9816 4.15171 16.0034C4.00839 16.0475 3.92217 16.1283 3.86939 16.2211C3.86937 16.2211 3.86936 16.2211 3.86935 16.2212M20.3713 25.3683L3.00003 15.7269L3.86935 16.2212M20.3713 25.3683C20.4047 25.5133 20.3781 25.6286 20.3238 25.7211L20.3235 25.7216C20.1827 25.9621 19.8831 26.0517 19.6334 25.9075L4.05312 16.9123C3.80385 16.7683 3.73117 16.4643 3.86935 16.2212M20.3713 25.3683L3.86935 16.2212M11.5925 25.3066C10.9942 25.6515 10.2336 25.6767 9.59327 25.307C8.95298 24.9373 8.59446 24.2661 8.59403 23.5754L11.5925 25.3066Z",
    stroke: "#4153D3",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDisable);
export default __webpack_public_path__ + "static/media/notification-disable.1c1b5fae241e3203f2ee6edad4741947.svg";
export { ForwardRef as ReactComponent };